<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class="flex md6 offset--md3">
            <va-input
              v-model="insertData.email"
              label="用户邮箱"
              removable
              :messages="message"
              :error="!!error.emailErrors.length"
              :error-messages="error.emailErrors"
            />
          </div>
          <div class="flex md6 offset--md3">
            <va-input
              v-model="insertData.password"
              label="原密码"
              removable
              type="password"
              :messages="message"
              :error="!!error.passwordErrors.length"
              :error-messages="error.passwordErrors"
            />
          </div>
          <div class="flex md6 offset--md3">
            <va-input
              v-model="insertData.newPassword"
              label="新密码"
              type="password"
              removable
              :messages="message"
              :error="!!error.newPasswordErrors.length"
              :error-messages="error.newPasswordErrors"
            />
          </div><div class="flex md6 offset--md3">
            <va-input
              v-model="insertData.confirmNewPassword"
              label="确认新密码"
              type="password"
              removable
              :messages="message"
              :error="!!error.confirmNewPasswordErrors.length"
              :error-messages="error.confirmNewPasswordErrors"
            />
          </div>
        </div>
        <div class="row justify--center">
          <va-button outline class="flex md1" color="info" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            提交
          </va-button>

        </div>
      </va-card>
    </div>
  </div>

</template>

<script>

import 'vue-trix'
import employeeApi from '@/api/employee'
export default {
  data () {
    return {
      insertData: {
        id: null,
        email: '',
        password: '',
        newPassword: '',
        confirmNewPassword: '',
      },
      message: ['Required field'],
      error: {
        emailErrors: [],
        passwordErrors: [],
        newPasswordErrors: [],
        confirmNewPasswordErrors: [],
      },
      title: '重置密码',
      submitButtonStatus: true,
      loading: true,
    }
  },
  created () {
  },
  computed: {
    formReady () {
      return !this.error.emailErrors.length &&
          !this.error.passwordErrors.length &&
          !this.error.newPasswordErrors.length &&
          !this.error.confirmNewPasswordErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady || !this.checkPassWord()) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        email: this.insertData.email,
        password: this.insertData.password,
        newPassword: this.insertData.newPassword,
      }
      employeeApi.resetPassword(data).then(response => {
        if (response.success === true) {
          this.showToast('更新密码成功,请重新登录', {
            duration: 5000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.changeButtonStatus(true)
          this.resetToken()
          this.$router.push({ name: 'login' })
        }
      }).catch(error => {
        this.error.emailErrors = ['请输入正确的邮箱或者正确的密码']
        this.error.passwordErrors = ['请输入正确的邮箱或者正确的密码']
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.changeButtonStatus(true)
      })
    },
    clickCancel () {
    },
    checkField () {
      this.error.emailErrors = this.insertData.email ? [] : ['email is required']
      this.error.passwordErrors = this.insertData.password ? [] : ['password is required']
      this.error.newPasswordErrors = this.insertData.newPassword ? [] : ['newPassword is required']
      this.error.confirmNewPasswordErrors = this.insertData.confirmNewPassword ? [] : ['confirmNewPassword is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    checkPassWord () {
      if (this.insertData.newPassword !== this.insertData.confirmNewPassword) {
        this.error.confirmNewPasswordErrors = ['新密码不一致']
        this.error.newPasswordErrors = ['新密码不一致']
        return false
      }
      return true
    },
    resetToken () {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('employeeId')
    },
  },
}

</script>

<style>
.permission-label {
  cursor: pointer;
}
</style>
